import React from "react";

const EyeIcon = ({ color, Text, width, height, textColor, flexDirection }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: flexDirection || "row",
      }}
    >
      <svg
        style={{ minWidth: "30px" }}
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 21 20"
        fill="none"
      >
        <g clip-path="url(#clip0_8395_10219)">
          <path
            d="M20.3752 9.62533C18.9235 7.68697 14.9402 3.771 10.5 3.771C6.37553 3.771 2.41373 7.23674 0.624746 9.62533C0.458418 9.8474 0.458418 10.1526 0.624746 10.3747C2.69893 13.144 6.64057 16.229 10.5 16.229C14.6244 16.229 18.5862 12.7632 20.3752 10.3746C20.5416 10.1526 20.5416 9.8474 20.3752 9.62533ZM10.5 14.979C7.25686 14.979 4.02229 12.491 1.92818 10.0002C2.95256 8.78322 6.44803 5.021 10.5 5.021C13.7431 5.021 16.9777 7.50897 19.0718 9.99982C18.0474 11.2167 14.5519 14.979 10.5 14.979Z"
            fill={color}
          />
          <path
            d="M10.5 6.25C8.43227 6.25 6.75 7.93227 6.75 10C6.75 12.0677 8.43227 13.75 10.5 13.75C12.5677 13.75 14.25 12.0677 14.25 10C14.25 7.93227 12.5677 6.25 10.5 6.25ZM10.5 12.5C9.12148 12.5 8 11.3785 8 10C8 8.62148 9.12148 7.5 10.5 7.5C11.8785 7.5 13 8.62148 13 10C13 11.3785 11.8785 12.5 10.5 12.5Z"
            fill={color}
          />
          <path
            d="M10.5007 11.0417C11.076 11.0417 11.5423 10.5754 11.5423 10.0001C11.5423 9.42475 11.076 8.95837 10.5007 8.95837C9.92536 8.95837 9.45898 9.42475 9.45898 10.0001C9.45898 10.5754 9.92536 11.0417 10.5007 11.0417Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_8395_10219">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="translate(0.5)"
            />
          </clipPath>
        </defs>
      </svg>
      <div
        className="popover-label"
        style={{ color: textColor ? textColor : "#fff", cursor: "pointer" }}
      >
        {Text}{" "}
      </div>
    </div>
  );
};

export default EyeIcon;
